import { render, staticRenderFns } from "./ViewSingleFBMessage.vue?vue&type=template&id=84ec7ad2&scoped=true&"
import script from "./ViewSingleFBMessage.vue?vue&type=script&lang=ts&"
export * from "./ViewSingleFBMessage.vue?vue&type=script&lang=ts&"
import style0 from "./ViewSingleFBMessage.vue?vue&type=style&index=0&id=84ec7ad2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ec7ad2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
